/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ContactDealerInlineForm_user$ref = any;
type PdpSharedCallDealerCta_user$ref = any;
type PdpSharedDealerDetailsStats_user$ref = any;
type PdpSharedSellerTabsVariant_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespDealerDetails_user$ref: FragmentReference;
export type PdpRespDealerDetails_user = {|
  +$fragmentRefs: PdpSharedDealerDetailsStats_user$ref & ContactDealerInlineForm_user$ref & PdpSharedSellerTabsVariant_user$ref & PdpSharedCallDealerCta_user$ref,
  +$refType: PdpRespDealerDetails_user$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespDealerDetails_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedDealerDetailsStats_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ContactDealerInlineForm_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerTabsVariant_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedCallDealerCta_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '81c8f7a89d990e9910827c47e3ed6a31';
module.exports = node;
